import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { FullPageLoading } from "@/components/common/Loading";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { completeGoogle } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const m = window.location.hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    (async () => {
      if (!sid) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const res = await completeGoogle(sid);
        window.history.replaceState(null, "", window.location.pathname);
        if (res && res.pending_deletion) {
          if (res.restorable === false) {
            navigate("/login?unavailable=1", { replace: true });
          } else {
            navigate(`/login?restore=1&email=${encodeURIComponent(res.email)}&purge=${encodeURIComponent(res.purge_at || "")}`, { replace: true });
          }
          return;
        }
        navigate(res.account_complete ? "/dashboard" : "/welcome", { replace: true });
      } catch {
        navigate("/login?error=google", { replace: true });
      }
    })();
  }, [completeGoogle, navigate]);

  return <FullPageLoading />;
}
